
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalCube as ObiBuoyConicalCubeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-cube.js';
 
 
 

 
 export const ObiBuoyConicalCube = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-cube',
   elementClass: ObiBuoyConicalCubeElement,
   events: {
     
   }
  });
 
 